import { IconButton } from '@creditornot/cb-button';
import { MoreHorizontal } from '@creditornot/cb-icons';
import { MenuActionItem, MenuItemGroup } from '@creditornot/cb-menu';
import { LegacyPopover } from '@creditornot/cb-popover';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = {
  onDelete: () => void;
};

const PopoverContent = styled.div`
  width: 200px;
  padding: 0 8px;
`;

const SshKeyContextMenu = ({ onDelete }: Props) => {
  const [show, setShow] = useState(false);

  const toggle = () => setShow(!show);
  const close = () => setShow(false);

  return (
    <LegacyPopover
      content={
        <PopoverContent>
          <MenuItemGroup>
            <MenuActionItem variant="red" onClick={onDelete}>
              <FormattedMessage id="merchant-integrations.sftp.delete-ssh.title" />
            </MenuActionItem>
          </MenuItemGroup>
        </PopoverContent>
      }
      placement="bottom-end"
      onClickOutside={close}
      show={show}
      renderArrow={false}
    >
      <IconButton size="small" variant="blue" onClick={toggle}>
        <MoreHorizontal />
      </IconButton>
    </LegacyPopover>
  );
};

export default SshKeyContextMenu;
